// AI integratsiya — xizmat sahifasi kontenti (uz / ru)
// SEO: "AI integratsiya", "sun'iy intellektni joriy etish", "AI CRM'ga ulash",
// "1C AI", "ERP sun'iy intellekt", "AI integratsiya narxi".

const uz = {
    meta: {
        title: "AI integratsiya — mavjud tizimga ulash, 25 mln so'mdan",
        description:
            "AI integratsiya — sun'iy intellektni mavjud CRM, ERP, 1C, sayt va Telegram botingizga ulash. Hech narsani qaytadan qurmasdan, API orqali, bosqichma-bosqich. Narx 25 mln so'mdan.",
        keywords: [
            "AI integratsiya",
            "sun'iy intellektni joriy etish",
            "AI CRM'ga ulash",
            "ERP sun'iy intellekt",
            "1C AI",
            "AI API integratsiya",
            "biznesda sun'iy intellekt",
            "AI integratsiya narxi",
            "ma'lumot xavfsizligi",
        ],
    },

    hero: {
        eyebrow: "AI integratsiya / Sun'iy intellektni joriy etish",
        h1: "AI integratsiya — 25 mln so'mdan",
        lead:
            "Sizda CRM, ombor tizimi, sayt va Telegram bot allaqachon bor. AI integratsiya — ularni tashlab yuborish emas, balki ichiga sun'iy intellektni qo'shish: matnni o'zi tushunadigan, hujjatni o'zi o'qiydigan va keyingi qadamni o'zi taklif qiladigan qilib.",
        ctaPrimary: "Bepul konsultatsiya olish",
        ctaSecondary: "Narxlarni ko'rish",
        proof: [
            "Mavjud tizimingiz saqlanadi",
            "Birinchi natija 4–6 haftada",
            "API orqali, kodni qayta yozmasdan",
            "Ma'lumot xavfsizligi shartnomada qayd etiladi",
        ],
    },

    intro: {
        h: "AI integratsiya nima va u yangi tizim qurishdan nimasi bilan farq qiladi?",
        p: [
            "AI integratsiya — sun'iy intellektni noldan tizim qurmasdan, allaqachon ishlayotgan dasturlaringizga ulash. Sizning CRM'ingiz, 1C'ingiz, ombor bazangiz va saytingiz joyida qoladi. Ular ustiga bitta qatlam qo'shiladi: u ma'lumotni o'qiydi, tahlil qiladi va natijani o'sha tizimning o'ziga qaytaradi — menejer yangi dastur o'rganishi shart emas.",
            "Farqi shunda. Yangi tizim qurish oylar oladi, xodimlarni qayta o'qitishni talab qiladi va eski ma'lumotni ko'chirish bilan bog'liq xavf tug'diradi. AI integratsiya esa bitta aniq nuqtadan boshlanadi: masalan, kelgan arizani o'zi tasniflab, kerakli menejerga yo'naltirish. Bu bitta funksiya 4–6 haftada ishga tushadi va natijasini darhol ko'rish mumkin.",
            "Amalda bu nimani anglatadi? Sayt formasidan kelgan xabar o'zi o'qiladi va CRM'da to'g'ri bosqichga tushadi. Skanerdan o'tgan hisob-faktura raqamlari qo'lda emas, avtomatik kiritiladi. Telegram bot endi faqat tugma emas, savolning ma'nosini tushunadi. Direktor esa «shu oyda qaysi mahsulot bo'yicha qaytarish ko'paydi?» deb oddiy til bilan so'rab, hisobot oladi.",
            "Innobek bu ishni bosqichma-bosqich olib boradi va har bosqichda o'lchanadigan natija qo'yadi. Avval integratsiya imkoniyati tekshiriladi: tizimingizda API bormi, ma'lumot qanday formatda, kim nimaga ruxsatga ega. Keyin bitta stsenariy ishga tushiriladi, o'lchanadi va faqat undan keyin kengaytiriladi. Bu yondashuv katta byudjetni bir yo'la xavf ostiga qo'ymaydi.",
        ],
    },

    definition: {
        term: "AI integratsiya nima?",
        text:
            "AI integratsiya — sun'iy intellekt modellarini kompaniyaning mavjud dasturlariga (CRM, ERP, 1C, sayt, bot) API orqali ulash jarayoni. Natijada eski tizim almashtirilmaydi, lekin u matnni tushunish, hujjatni o'qish va tavsiya berish qobiliyatiga ega bo'ladi.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Har bir loyihaga standart tarzda kiradi",
        sub: "Bular alohida to'lanadigan qo'shimcha emas — bazaviy tarifda ham bor.",
        items: [
            "Bepul konsultatsiya va mavjud tizimlar auditi",
            "Integratsiya imkoniyatini tekshirish: API, baza, formatlar, ruxsatlar",
            "Eng ko'p foyda beradigan stsenariyni tanlash va asoslash",
            "Ma'lumotni tayyorlash va tozalash",
            "Model tanlash: bulut xizmati yoki o'z serveringizdagi model",
            "Tizimingiz bilan ikki tomonlama API ulanish",
            "Xatoliklarni qayta ishlash: AI ishlamasa, eski jarayon to'xtamaydi",
            "Ma'lumot xavfsizligi: shifrlash, ruxsatlar va audit jurnali",
            "Sinov muhiti va bosqichma-bosqich ishga tushirish",
            "Natijani o'lchash: vaqt tejash, xatolar va sifat ko'rsatkichlari",
            "Xodimlar uchun qo'llanma va o'qitish sessiyasi",
            "Ishga tushgandan keyin 6 oylik texnik qo'llab-quvvatlash",
        ],
    },

    benefits: {
        eyebrow: "Nega kerak",
        h: "AI integratsiya biznesga nima beradi?",
        sub: "Bu — tizimni almashtirish emas, undan ko'proq foyda olish.",
        items: [
            {
                t: "Mavjud investitsiya saqlanadi",
                d: "CRM yoki ERP'ga yillar davomida ma'lumot va pul kiritilgan. AI integratsiya ularni tashlamaydi — aksincha, to'plangan ma'lumotni ishlatib, tizim qiymatini oshiradi.",
            },
            {
                t: "Tez natija",
                d: "To'liq yangi tizim 6–12 oy oladi. Bitta AI stsenariysi esa 4–6 haftada ishga tushadi va uni o'chirish ham oson — bu xavfni sezilarli kamaytiradi.",
            },
            {
                t: "Qo'lda kiritish kamayadi",
                d: "Hisob-faktura, pasport ma'lumoti, shartnoma sharti va sayt arizasi avtomatik o'qiladi va maydonlarga tushadi. Xodim faqat tasdiqlaydi.",
            },
            {
                t: "Xodim o'rganishi shart emas",
                d: "AI ular kundalik ishlatadigan interfeys ichida paydo bo'ladi: CRM kartasida, 1C hisobotida yoki Telegram'da. Yangi dastur, yangi parol, yangi odat kerak emas.",
            },
            {
                t: "Ma'lumot javob bera boshlaydi",
                d: "Bazadagi ma'lumotni SQL bilmasdan, oddiy savol bilan so'rash mumkin bo'ladi. Hisobotni tayyorlash uchun IT bo'limiga navbat kutilmaydi.",
            },
            {
                t: "Xavfsizlik nazorat ostida",
                d: "Qaysi ma'lumot modelga uzatilishini biz siz bilan ro'yxat qilib kelishamiz. Shaxsiy ma'lumotlar niqoblanadi, talab bo'lsa model sizning serveringizda ishlaydi.",
            },
            {
                t: "Bosqichma-bosqich o'sish",
                d: "Birinchi stsenariy natija bersa, ikkinchisi arzonroq tushadi — chunki ulanish, ruxsatlar va monitoring allaqachon qurilgan bo'ladi.",
            },
            {
                t: "Eski jarayon to'xtamaydi",
                d: "AI qatlami alohida ishlaydi. U uzilib qolsa yoki javob bermasa, tizim eski qo'lda rejimga qaytadi — ish jarayoni to'xtab qolmaydi.",
            },
            {
                t: "Xarajat ko'rinib turadi",
                d: "Token sarfi bo'yicha limit va ogohlantirish qo'yiladi, har bir stsenariy qancha turgani panelda ko'rinadi. Foyda bermayotgan stsenariyni o'chirish bir tugma.",
            },
        ],
    },

    audience: {
        eyebrow: "Qayerda qo'llaniladi",
        h: "Qaysi tizimlarga AI ulanadi",
        sub: "Eng ko'p so'raladigan va eng tez o'zini oqlaydigan yo'nalishlar.",
        items: [
            {
                t: "CRM: lidlarni tasniflash",
                d: "Kelgan murojaat matni o'qiladi, mavzusi va shoshilinchligi aniqlanadi, kerakli menejerga yo'naltiriladi. Suhbat qisqacha xulosa bilan kartaga yoziladi.",
            },
            {
                t: "1C va ERP: hujjatlarni o'qish",
                d: "Skaner yoki PDF ko'rinishidagi hisob-faktura, akt va shartnoma tanib olinadi, raqamlar tizim maydonlariga tushadi. Xodim tekshirib tasdiqlaydi.",
            },
            {
                t: "Sayt: aqlli qidiruv va tavsiya",
                d: "Katalogda qidiruv so'zma-so'z emas, ma'no bo'yicha ishlaydi. Mahsulot tavsiflari yarim avtomatik yoziladi, o'xshash tovarlar tavsiya qilinadi.",
            },
            {
                t: "Telegram bot: ma'noni tushunish",
                d: "Tugmali bot erkin yozilgan savolga javob beradigan bo'ladi. Bilmagan savolni menejerga uzatadi, ariza ma'lumotini esa CRM'ga yozadi.",
            },
            {
                t: "Qo'ng'iroqlar va yozishmalar tahlili",
                d: "Suhbat matnga aylantiriladi, undan e'tiroz, so'rov va va'dalar ajratiladi. Sifat nazorati bir necha qo'ng'iroq o'rniga hammasini qamrab oladi.",
            },
            {
                t: "Hisobotlar: oddiy til bilan so'rash",
                d: "«Mart oyida qaysi filial rejani bajarmadi?» — savol yoziladi, tizim bazadan ma'lumot olib, javob va grafikni qaytaradi.",
            },
            {
                t: "Ichki bilim bazasi",
                d: "Reglament, yo'riqnoma va shartnoma namunalari bo'yicha xodimlar savol berib javob oladi. Yangi xodimni ishga kirishtirish tezlashadi.",
            },
            {
                t: "Ombor va yetkazib berish",
                d: "Ta'minotchi xatlari va yuk hujjatlari avtomatik o'qiladi, qoldiq prognozi tuziladi. Tugab qolish xavfi bor pozitsiyalar ro'yxati har kuni o'zi shakllanadi.",
            },
            {
                t: "Buxgalteriya va moliya",
                d: "To'lovlar toifalarga ajratiladi, kutilmagan xarajat va takroriy hisob aniqlanadi. Oylik yopilishda xodim hamma yozuvni emas, faqat shubhalilarini ko'radi.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "AI integratsiya narxi — 3 ta tarif",
        sub: "Narxlar bir martalik ishlanma uchun. Har bir tarifga audit, integratsiya va o'qitish kiradi.",
        note:
            "Narxlar 2026-yil uchun ko'rsatilgan va yakuniy hisob-kitob bepul auditdan keyin tasdiqlanadi. AI modelidan foydalanish to'lovi (token) alohida bo'lib, u to'g'ridan-to'g'ri provayderga to'lanadi — hajmga qarab odatda oyiga 1–10 mln so'm oralig'ida. Konsultatsiyada taxminiy hisobini ko'rsatamiz.",
        tiers: [
            {
                name: "Start",
                tagline: "Bitta stsenariy, bitta tizim",
                price: "25 000 000",
                priceNote: "so'mdan",
                term: "4–6 hafta",
                best: "AI sizning ma'lumotingizda foyda berishini tez tekshirish",
                features: [
                    "Mavjud tizimlar auditi va integratsiya imkoniyati hisoboti",
                    "Bitta stsenariy: tasniflash, xulosalash yoki hujjat o'qish",
                    "Bitta tizimga ulanish (CRM, sayt yoki bot)",
                    "Bilim bazasi yoki ma'lumot to'plamini tayyorlash",
                    "API integratsiya va xatoliklarni qayta ishlash",
                    "Natijani o'lchash uchun oddiy panel",
                    "Ma'lumot uzatish qoidalari va shaxsiy ma'lumotni niqoblash",
                    "Sinov muhitida tekshirish va bosqichma-bosqich yoqish",
                    "Xodimlarni o'rgatish (1 sessiya)",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Biznes",
                tagline: "Bir nechta tizim va stsenariy",
                price: "70 000 000",
                priceNote: "so'mdan",
                term: "8–12 hafta",
                featured: true,
                best: "AI'ni sotuv, hujjat va qo'llab-quvvatlash jarayonlariga yoyish",
                features: [
                    "Barcha Start imkoniyatlari",
                    "3–5 ta stsenariy bir vaqtda",
                    "CRM, 1C/ERP va sayt bilan bir vaqtda ulanish",
                    "Kompaniya hujjatlari bo'yicha qidiruv (RAG) tizimi",
                    "Qo'ng'iroq va yozishmalarni matnga aylantirish va tahlil",
                    "Oddiy til bilan hisobot so'rash moduli",
                    "Rollar, ruxsatlar va to'liq audit jurnali",
                    "Sifat monitoringi: javob aniqligi va xato statistikasi",
                    "Xarajat nazorati: token sarfi limitlari va ogohlantirish",
                    "Ikki bo'lim uchun o'qitish va reglament",
                    "6 oylik texnik qo'llab-quvvatlash",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Yopiq kontur va yuqori talablar",
                price: "Kelishuv",
                priceNote: "asosida",
                term: "Loyihaga qarab",
                best: "Moliya, tibbiyot va davlat sektori kabi qat'iy talabli sohalar",
                features: [
                    "O'z serveringizda ishlaydigan model — ma'lumot tashqariga chiqmaydi",
                    "Ichki tizimlar bilan chuqur integratsiya va ma'lumot shini",
                    "Xavfsizlik auditi va tashqi tekshiruvga tayyorlash",
                    "Bir nechta filial va yuqori yuklamaga masshtablash",
                    "MLOps: modelni yangilash, versiyalash va qaytarish imkoni",
                    "SLA va ustuvor qo'llab-quvvatlash",
                    "Ichki jamoangizni o'qitish va texnik hujjatlarni topshirish",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "AI integratsiya qanday amalga oshiriladi",
        sub: "Olti bosqich. Har bosqich oxirida o'lchanadigan natija bo'ladi.",
        steps: [
            {
                t: "Audit va imkoniyat tahlili",
                time: "1–2 hafta",
                d: "Mavjud tizimlaringiz, ma'lumot formatlari va API'lari o'rganiladi. Qaysi stsenariy eng ko'p vaqt tejashini raqam bilan asoslaymiz.",
            },
            {
                t: "Stsenariy va mezonlarni kelishish",
                time: "3–5 kun",
                d: "Bitta stsenariy tanlanadi va muvaffaqiyat mezoni yoziladi: masalan, ariza tasnifi 90% to'g'ri bo'lsin va qo'lda ishlov 2 barobar kamaysin.",
            },
            {
                t: "Ma'lumot va xavfsizlik",
                time: "1–2 hafta",
                d: "Qaysi ma'lumot modelga boradi va qaysi biri niqoblanadi — ro'yxat qilib kelishiladi. Ruxsatlar, shifrlash va audit jurnali sozlanadi.",
            },
            {
                t: "Integratsiya ishlanmasi",
                time: "2–5 hafta",
                d: "AI qatlami quriladi va tizimingizga API orqali ulanadi. Xatolik holatlari, limitlar va eski rejimga qaytish yo'li ham yoziladi.",
            },
            {
                t: "Sinov va bosqichma-bosqich yoqish",
                time: "2–3 hafta",
                d: "Avval sinov muhitida, so'ng bitta bo'lim yoki murojaatlarning 10 foizida ishlatiladi. Natija yaxshi bo'lsa, qamrov kengaytiriladi.",
            },
            {
                t: "Kuzatish va sozlash",
                time: "davomiy",
                d: "Javob sifati, token sarfi va xato statistikasi kuzatiladi. Yig'ilgan xatolar asosida so'rovlar va qoidalar muntazam yaxshilanadi.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Biz ishlagan loyihalar",
        sub: "Mavjud tizimlarni bog'lash va avtomatlashtirish bo'yicha yechimlar — tahlildan ishga tushirishgacha.",
        cta: "Barcha loyihalar",
        slugs: ["grandpharm", "logistatrans-app", "besh-market-app", "imtihan"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "AI integratsiya bo'yicha eng ko'p so'raladigan savollarga qisqa javoblar.",
        items: [
            {
                q: "AI integratsiya qancha turadi?",
                a: "Bitta tizimga bitta stsenariyni ulash 25 000 000 so'mdan boshlanadi — bu audit, integratsiya, sinov va o'qitishni o'z ichiga oladi. Bir nechta tizim va 3–5 ta stsenariy uchun narx 70 000 000 so'mdan. Yopiq konturda o'z serveringizda ishlaydigan model kerak bo'lsa, narx kelishuv asosida belgilanadi.",
            },
            {
                q: "Mening CRM'im bilan ishlaydimi?",
                a: "Bitrix24, amoCRM, 1C va ko'pchilik zamonaviy tizimlarda ochiq API bor — ular bilan ishlaymiz. O'zingiz uchun yozilgan tizim bo'lsa ham odatda yo'l topiladi: API, bazaga to'g'ridan-to'g'ri ulanish yoki fayl almashinuvi orqali. Bunga javobni audit bosqichida aniq beramiz, taxmin qilmaymiz. Agar ulanish texnik jihatdan imkonsiz bo'lsa, buni ham ochiq aytamiz va loyihani boshlamaymiz.",
            },
            {
                q: "Ma'lumotlarim tashqariga chiqadimi?",
                a: "Bu siz tanlaydigan masala. Bulut modelidan foydalansak, modelga faqat siz ruxsat bergan maydonlar yuboriladi, shaxsiy ma'lumotlar esa niqoblanadi: ism, telefon va hisob raqami o'rniga shartli belgilar ketadi. Agar hech qanday ma'lumot chiqmasligi talab qilinsa, model sizning serveringizda o'rnatiladi. Ikkala holatda ham shartlar shartnomada aniq yoziladi.",
            },
            {
                q: "Loyiha qancha vaqt oladi?",
                a: "Bitta stsenariy 4–6 haftada ishga tushadi, bir nechta tizimni qamraydigan loyiha 8–12 hafta oladi. Muddatning katta qismi ishlanmaga emas, ma'lumotga ketadi: uni tozalash, ruxsatlarni kelishish va sinov. Sizning tarafingizdan qaror qabul qila oladigan mas'ul shaxs bo'lsa, jarayon bir-ikki haftaga tezlashadi.",
            },
            {
                q: "Oylik to'lov bormi?",
                a: "Ha, agar bulut modelidan foydalanilsa — token to'lovi so'rovlar hajmiga bog'liq. Odatda bu oyiga 1–10 mln so'm oralig'ida bo'ladi va to'g'ridan-to'g'ri provayderga to'lanadi. Biz tizimga sarf limiti va ogohlantirish qo'yamiz, shunda hisob kutilmaganda oshib ketmaydi. O'z serveringizdagi model bunday to'lovsiz ishlaydi.",
            },
            {
                q: "AI noto'g'ri javob bersa nima bo'ladi?",
                a: "Bunga oldindan tayyorlanamiz. Muhim jarayonlarda AI natijasi avtomatik qo'llanmaydi — u taklif sifatida ko'rsatiladi va yakuniy qarorni xodim tasdiqlaydi. Ishonchi past bo'lgan holat avtomatik ravishda odamga uzatiladi. Har bir xato jurnalga yoziladi, keyin so'rovlar va qoidalar shu asosda tuzatiladi, shunda o'sha xato takrorlanmaydi.",
            },
            {
                q: "Nimadan boshlash kerak?",
                a: "Eng ko'p qo'l mehnati ketayotgan bitta jarayondan. Ko'pincha bu — kelgan arizalarni qo'lda tasniflash yoki hujjatdagi raqamlarni tizimga ko'chirish. Audit bosqichida biz shu joyni topamiz va tejaladigan vaqtni soatlarda ko'rsatamiz. Faqat shu hisob mantiqli chiqsa, ishlanmaga o'tamiz — aks holda boshqa nuqtani qidiramiz.",
            },
            {
                q: "Xodimlarni o'qitish kiradimi?",
                a: "Ha, barcha tariflarda. Ishga tushirishdan oldin qo'llanma tayyorlaymiz va amaliy sessiya o'tkazamiz: AI nima qila oladi, nimani qila olmaydi va natijani qanday tekshirish kerak. Biznes tarifida ikkita bo'lim uchun alohida reglament tuziladi. Birinchi oyda paydo bo'ladigan savollar bo'yicha doimiy aloqada bo'lamiz.",
            },
            {
                q: "Eski tizimimni qaytadan yozish kerakmi?",
                a: "Deyarli hech qachon. AI qatlami tizimingizdan tashqarida turadi va u bilan API orqali gaplashadi, shuning uchun mavjud kodga tegilmaydi. Faqat tizim juda eski bo'lib, hech qanday ulanish imkoni bo'lmasa, oraliq yechim qo'llaniladi — bazaga o'qish rejimida ulanish yoki jadval ko'rinishidagi fayl almashinuvi.",
            },
            {
                q: "Qaysi holatda AI integratsiya kerak emas?",
                a: "Agar jarayonda tartib bo'lmasa. Ma'lumot bir necha Excel faylida tarqoq yotgan va kim nima kiritishi belgilanmagan bo'lsa, AI bu chalkashlikni tezlashtiradi xolos. Bunday holatda avval jarayonni tartibga solish kerak. Buni biz ochiq aytamiz va oddiy avtomatlashtirishdan boshlashni taklif qilamiz — bu arzonroq tushadi.",
            },
        ],
    },

    cta: {
        h: "Qaysi jarayoningiz eng ko'p qo'l mehnati talab qiladi?",
        p: "Bepul auditda mavjud tizimlaringizni ko'rib chiqamiz, AI qayerda foyda berishini va qayerda bermasligini aytamiz, aniq narx bilan muddat beramiz. Telefon: +998 90 954 12 62.",
        button: "Bepul audit so'rash",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/ai-integratsiya-hero.webp",
            alt: "AI integratsiya sxemasi: sun'iy intellekt qatlami CRM, ERP, sayt va Telegram botga ulangan",
            caption: "AI qatlami mavjud tizimlar ustida turadi va ular bilan API orqali gaplashadi.",
            prompt: "Clean isometric technical diagram on a dark graphite background: a central glowing node labelled 'AI LAYER' connected by luminous cyan lines to four surrounding boxes labelled CRM, ERP / 1C, WEBSITE and TELEGRAM BOT. Small API badges on each connection line. Minimal, modern, violet and cyan accents, no photographic elements, no real brand logos. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-crm.webp",
            alt: "CRM kartasida AI yordamchisi murojaatni tasniflab, qisqacha xulosa va keyingi qadamni taklif qilmoqda",
            caption: "Murojaat o'zi tasniflanadi, xulosa esa to'g'ridan-to'g'ri CRM kartasiga tushadi.",
            prompt: "Screenshot-style mockup of a CRM deal card in a dark UI: customer details on the left, and on the right an AI side panel showing an auto-generated summary, a priority tag 'HIGH', and a suggested next action button. Generic placeholder names and text, cyan accent color, crisp modern SaaS interface, no real brand names. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-hujjat.webp",
            alt: "Hisob-faktura skanerdan avtomatik o'qilib, 1C va ERP tizimi maydonlariga ko'chirilmoqda",
            caption: "Hujjatdagi raqamlar qo'lda emas, avtomatik ravishda tizim maydonlariga tushadi.",
            prompt: "Split composition: on the left a scanned invoice document with several fields highlighted by thin cyan rectangles; on the right the same values appearing in a structured data form in an ERP-style dark interface, connected by soft glowing arrows. Generic placeholder invoice with unreadable filler text and neutral numbers, clean and technical look. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-xavfsizlik.webp",
            alt: "AI integratsiyada ma'lumot xavfsizligi: shifrlash, niqoblash va ruxsatlar nazorati sxemasi",
            caption: "Modelga faqat kelishilgan maydonlar boradi, shaxsiy ma'lumotlar niqoblanadi.",
            prompt: "Abstract security diagram on a dark background: a data stream flowing left to right through three labelled gates — 'MASKING', 'ENCRYPTION', 'ACCESS CONTROL' — before reaching a node labelled 'AI MODEL'. Some data blocks shown as blurred/redacted bars. Minimal line art with cyan and amber accents, technical infographic style, no people. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-hisobot.webp",
            alt: "Oddiy til bilan so'ralgan savol asosida AI tizimdan hisobot va grafik qaytarmoqda",
            caption: "Hisobot uchun SQL ham, IT bo'limi navbati ham kerak emas.",
            prompt: "Dark-themed analytics interface where a chat input at the bottom contains a natural-language business question, and above it the system has rendered an answer paragraph plus a bar chart and a small data table. Generic placeholder labels and numbers, violet and cyan accents, clean modern dashboard rendering, no real brand names. 16:9.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-agent", "computer-vision", "crm-tizimlar", "biznes-avtomatlashtirish"],
};

const ru = {
    meta: {
        title: "AI-интеграция — внедрение ИИ в вашу систему, от 25 млн сум",
        description:
            "AI-интеграция — подключение искусственного интеллекта к вашим CRM, ERP, 1С, сайту и Telegram-боту. Без переписывания систем, через API, поэтапно. Цена от 25 млн сум.",
        keywords: [
            "AI-интеграция",
            "внедрение искусственного интеллекта",
            "ИИ в CRM",
            "ИИ в ERP",
            "1С искусственный интеллект",
            "интеграция AI по API",
            "искусственный интеллект для бизнеса",
            "AI-интеграция цена",
            "безопасность данных",
        ],
    },

    hero: {
        eyebrow: "AI-интеграция / Внедрение искусственного интеллекта",
        h1: "AI-интеграция — от 25 млн сум",
        lead:
            "У вас уже есть CRM, складская система, сайт и Telegram-бот. AI-интеграция — это не отказ от них, а встраивание искусственного интеллекта в них: чтобы система сама понимала текст, читала документы и предлагала следующий шаг.",
        ctaPrimary: "Получить бесплатную консультацию",
        ctaSecondary: "Посмотреть цены",
        proof: [
            "Ваши системы остаются на месте",
            "Первый результат за 4–6 недель",
            "Через API, без переписывания кода",
            "Безопасность данных закрепляется в договоре",
        ],
    },

    intro: {
        h: "Что такое AI-интеграция и чем она отличается от новой системы?",
        p: [
            "AI-интеграция — это подключение искусственного интеллекта к уже работающим программам без создания системы с нуля. Ваша CRM, 1С, складская база и сайт остаются на месте. Поверх них добавляется один слой: он читает данные, анализирует их и возвращает результат в ту же систему — менеджеру не нужно осваивать новую программу.",
            "Разница именно в этом. Разработка новой системы занимает месяцы, требует переобучения сотрудников и несёт риск при переносе старых данных. AI-интеграция же начинается с одной конкретной точки: например, входящая заявка сама классифицируется и уходит нужному менеджеру. Такая функция запускается за 4–6 недель, и результат виден сразу.",
            "Что это значит на практике? Сообщение с формы на сайте читается автоматически и попадает в CRM на нужный этап. Цифры из отсканированного счёта вносятся не руками, а автоматически. Telegram-бот перестаёт быть набором кнопок и начинает понимать смысл вопроса. А директор спрашивает обычными словами «по какому товару в этом месяце выросли возвраты?» и получает отчёт.",
            "Innobek ведёт такие проекты поэтапно и на каждом этапе фиксирует измеримый результат. Сначала проверяется сама возможность интеграции: есть ли в системе API, в каком формате данные, у кого какие права. Затем запускается один сценарий, измеряется, и только после этого охват расширяется. Такой подход не ставит под риск весь бюджет сразу.",
        ],
    },

    definition: {
        term: "Что такое AI-интеграция?",
        text:
            "AI-интеграция — процесс подключения моделей искусственного интеллекта к существующим программам компании (CRM, ERP, 1С, сайт, бот) через API. Старая система при этом не заменяется, но получает способность понимать текст, читать документы и давать рекомендации.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Входит в каждый проект по умолчанию",
        sub: "Это не платные опции — они есть и в базовом тарифе.",
        items: [
            "Бесплатная консультация и аудит существующих систем",
            "Проверка возможности интеграции: API, база, форматы, права доступа",
            "Выбор сценария с наибольшей отдачей и его обоснование",
            "Подготовка и очистка данных",
            "Подбор модели: облачный сервис или модель на вашем сервере",
            "Двусторонняя интеграция по API с вашей системой",
            "Обработка сбоев: при отказе AI старый процесс не останавливается",
            "Безопасность данных: шифрование, права доступа и журнал аудита",
            "Тестовая среда и поэтапный запуск",
            "Измерение результата: экономия времени, ошибки и качество",
            "Инструкция для сотрудников и обучающая сессия",
            "6 месяцев технической поддержки после запуска",
        ],
    },

    benefits: {
        eyebrow: "Зачем это нужно",
        h: "Что AI-интеграция даёт бизнесу",
        sub: "Это не замена системы, а способ получить от неё больше.",
        items: [
            {
                t: "Сохраняются прежние вложения",
                d: "В CRM или ERP годами вкладывались деньги и накапливались данные. AI-интеграция их не выбрасывает — наоборот, использует накопленные данные и повышает ценность системы.",
            },
            {
                t: "Быстрый результат",
                d: "Разработка полностью новой системы занимает 6–12 месяцев. Один сценарий AI запускается за 4–6 недель, и его так же легко отключить — это заметно снижает риск.",
            },
            {
                t: "Меньше ручного ввода",
                d: "Счета, паспортные данные, условия договора и заявки с сайта читаются автоматически и раскладываются по полям. Сотруднику остаётся только подтвердить.",
            },
            {
                t: "Сотрудникам не нужно переучиваться",
                d: "AI появляется внутри привычного интерфейса: в карточке CRM, в отчёте 1С или в Telegram. Новая программа, новый пароль и новая привычка не нужны.",
            },
            {
                t: "Данные начинают отвечать",
                d: "Спросить базу можно обычным вопросом, не зная SQL. Чтобы получить отчёт, не нужно вставать в очередь к ИТ-отделу и ждать неделю.",
            },
            {
                t: "Безопасность под контролем",
                d: "Какие данные уходят в модель, мы согласуем с вами списком. Персональные данные маскируются, а при необходимости модель разворачивается на вашем сервере.",
            },
            {
                t: "Рост по шагам",
                d: "Если первый сценарий дал результат, второй обходится дешевле — подключение, права доступа и мониторинг к тому моменту уже построены.",
            },
            {
                t: "Старый процесс продолжает работать",
                d: "Слой AI работает отдельно. Если он недоступен или не отвечает, система возвращается к прежнему ручному режиму, и работа не останавливается.",
            },
            {
                t: "Расходы видны",
                d: "По расходу токенов ставятся лимиты и оповещения, а стоимость каждого сценария видна на панели. Отключить сценарий, который не окупается, — одна кнопка.",
            },
        ],
    },

    audience: {
        eyebrow: "Где применяется",
        h: "К каким системам подключают AI",
        sub: "Направления, которые запрашивают чаще всего и которые быстрее окупаются.",
        items: [
            {
                t: "CRM: классификация заявок",
                d: "Текст обращения читается, определяются тема и срочность, заявка уходит нужному менеджеру. Разговор попадает в карточку в виде краткого резюме.",
            },
            {
                t: "1С и ERP: чтение документов",
                d: "Счета, акты и договоры в виде скана или PDF распознаются, цифры попадают в поля системы. Сотрудник проверяет и подтверждает.",
            },
            {
                t: "Сайт: умный поиск и рекомендации",
                d: "Поиск по каталогу работает по смыслу, а не по точному совпадению слов. Описания товаров пишутся полуавтоматически, похожие позиции рекомендуются.",
            },
            {
                t: "Telegram-бот: понимание смысла",
                d: "Кнопочный бот начинает отвечать на свободно сформулированный вопрос. Если тема незнакома, передаёт диалог менеджеру, а данные заявки записывает в CRM.",
            },
            {
                t: "Анализ звонков и переписок",
                d: "Разговор переводится в текст, из него выделяются возражения, запросы и обещания. Контроль качества охватывает все обращения, а не выборку.",
            },
            {
                t: "Отчёты обычными словами",
                d: "«Какой филиал не выполнил план в марте?» — вопрос задаётся текстом, система берёт данные из базы и возвращает ответ вместе с графиком.",
            },
            {
                t: "Внутренняя база знаний",
                d: "Сотрудники задают вопросы по регламентам, инструкциям и шаблонам договоров и получают ответ. Ввод нового сотрудника в работу заметно ускоряется.",
            },
            {
                t: "Склад и поставки",
                d: "Письма поставщиков и товарные документы читаются автоматически, строится прогноз остатков. Список позиций, которые рискуют закончиться, формируется каждый день автоматически.",
            },
            {
                t: "Бухгалтерия и финансы",
                d: "Платежи раскладываются по категориям, выявляются нетипичные траты и задвоенные счета. При закрытии месяца сотрудник смотрит не все проводки, а только спорные.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Стоимость AI-интеграции — три тарифа",
        sub: "Цены разовые, за разработку. В каждый тариф входят аудит, интеграция и обучение.",
        note:
            "Цены указаны на 2026 год, итоговая смета подтверждается после бесплатного аудита. Оплата использования AI-модели (токены) считается отдельно и идёт напрямую провайдеру — обычно от 1 до 10 млн сум в месяц в зависимости от объёма. Приблизительный расчёт мы показываем на консультации.",
        tiers: [
            {
                name: "Start",
                tagline: "Один сценарий, одна система",
                price: "25 000 000",
                priceNote: "сум",
                term: "4–6 недель",
                best: "Быстро проверить, даёт ли AI отдачу на ваших данных",
                features: [
                    "Аудит систем и отчёт о возможности интеграции",
                    "Один сценарий: классификация, резюмирование или чтение документов",
                    "Подключение к одной системе (CRM, сайт или бот)",
                    "Подготовка базы знаний или набора данных",
                    "Интеграция по API и обработка сбоев",
                    "Простая панель для измерения результата",
                    "Правила передачи данных и маскирование персональных данных",
                    "Проверка в тестовой среде и поэтапное включение",
                    "Обучение сотрудников (1 сессия)",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Бизнес",
                tagline: "Несколько систем и сценариев",
                price: "70 000 000",
                priceNote: "сум",
                term: "8–12 недель",
                featured: true,
                best: "Распространить AI на продажи, документооборот и поддержку",
                features: [
                    "Все возможности тарифа Start",
                    "3–5 сценариев одновременно",
                    "Одновременное подключение к CRM, 1С/ERP и сайту",
                    "Поиск по документам компании (RAG)",
                    "Перевод звонков и переписок в текст с последующим анализом",
                    "Модуль запроса отчётов на естественном языке",
                    "Роли, права доступа и полный журнал аудита",
                    "Мониторинг качества: точность ответов и статистика ошибок",
                    "Контроль расходов: лимиты по токенам и оповещения",
                    "Обучение и регламенты для двух подразделений",
                    "6 месяцев технической поддержки",
                ],
            },
            {
                name: "Enterprise",
                tagline: "Закрытый контур и повышенные требования",
                price: "По договорённости",
                priceNote: "индивидуально",
                term: "Зависит от проекта",
                best: "Финансы, медицина, госсектор и другие сферы со строгими требованиями",
                features: [
                    "Модель на вашем сервере — данные не покидают контур",
                    "Глубокая интеграция с внутренними системами и шиной данных",
                    "Аудит безопасности и подготовка к внешней проверке",
                    "Масштабирование на сеть филиалов и высокую нагрузку",
                    "MLOps: обновление, версионирование и откат моделей",
                    "SLA и приоритетная поддержка",
                    "Обучение вашей команды и передача технической документации",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как проходит AI-интеграция",
        sub: "Шесть этапов. В конце каждого есть измеримый результат.",
        steps: [
            {
                t: "Аудит и анализ возможностей",
                time: "1–2 недели",
                d: "Изучаем ваши системы, форматы данных и доступные API. Обосновываем цифрами, какой сценарий сэкономит больше всего времени.",
            },
            {
                t: "Согласование сценария и критериев",
                time: "3–5 дней",
                d: "Выбираем один сценарий и фиксируем критерий успеха: например, классификация заявок верна в 90% случаев, ручная обработка сокращается вдвое.",
            },
            {
                t: "Данные и безопасность",
                time: "1–2 недели",
                d: "Согласуем списком, какие данные уходят в модель, а какие маскируются. Настраиваем права доступа, шифрование и журнал аудита.",
            },
            {
                t: "Разработка интеграции",
                time: "2–5 недель",
                d: "Строим слой AI и подключаем его к вашей системе по API. Прописываем сценарии сбоев, лимиты и путь возврата к прежнему режиму.",
            },
            {
                t: "Тест и поэтапное включение",
                time: "2–3 недели",
                d: "Сначала тестовая среда, затем одно подразделение или 10% обращений. Если результат устраивает, охват расширяется.",
            },
            {
                t: "Наблюдение и настройка",
                time: "постоянно",
                d: "Следим за качеством ответов, расходом токенов и статистикой ошибок. На основе накопленных ошибок регулярно улучшаем запросы и правила.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Проекты, над которыми мы работали",
        sub: "Решения по объединению и автоматизации существующих систем — от анализа до запуска.",
        cta: "Все проекты",
        slugs: ["grandpharm", "logistatrans-app", "besh-market-app", "imtihan"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Короткие ответы на то, что спрашивают об интеграции AI чаще всего.",
        items: [
            {
                q: "Сколько стоит AI-интеграция?",
                a: "Подключение одного сценария к одной системе начинается от 25 000 000 сум — сюда входят аудит, интеграция, тестирование и обучение. Для нескольких систем и 3–5 сценариев цена от 70 000 000 сум. Если нужен закрытый контур с моделью на вашем сервере, стоимость определяется индивидуально.",
            },
            {
                q: "Будет ли это работать с моей CRM?",
                a: "У Bitrix24, amoCRM, 1С и большинства современных систем есть открытый API — с ними мы работаем. Если система написана под вас, выход обычно тоже находится: через API, прямое подключение к базе или обмен файлами. Точный ответ мы даём на этапе аудита, а не строим предположения заранее.",
            },
            {
                q: "Уйдут ли мои данные наружу?",
                a: "Это вы решаете сами. При использовании облачной модели туда передаются только те поля, которые вы разрешили, а персональные данные маскируются: вместо имени, телефона и номера счёта уходят условные метки. Если требуется, чтобы наружу не уходило ничего, модель разворачивается на вашем сервере. В обоих случаях условия фиксируются в договоре.",
            },
            {
                q: "Сколько времени занимает проект?",
                a: "Один сценарий запускается за 4–6 недель, проект с несколькими системами занимает 8–12 недель. Большая часть срока уходит не на разработку, а на данные: их очистку, согласование прав доступа и тестирование. Если с вашей стороны есть ответственный сотрудник, процесс идёт заметно быстрее.",
            },
            {
                q: "Есть ли ежемесячная оплата?",
                a: "Да, если используется облачная модель — оплата токенов зависит от объёма запросов. Обычно это от 1 до 10 млн сум в месяц, и платить нужно напрямую провайдеру. Мы ставим в систему лимиты расхода и оповещения, чтобы счёт не вырос неожиданно. Модель на вашем сервере работает без такой оплаты.",
            },
            {
                q: "Что будет, если AI ответит неверно?",
                a: "К этому мы готовимся заранее. В важных процессах результат AI не применяется автоматически — он показывается как предложение, а окончательное решение подтверждает сотрудник. Случаи с низкой уверенностью автоматически передаются человеку. Каждая ошибка записывается в журнал, и на её основе корректируются запросы и правила, чтобы она не повторялась.",
            },
            {
                q: "С чего начать внедрение?",
                a: "С того процесса, где больше всего ручной работы. Чаще всего это ручная сортировка входящих заявок или перенос цифр из документов в систему. На этапе аудита мы находим такое место и показываем в цифрах, сколько времени экономится, и только потом переходим к разработке.",
            },
            {
                q: "Входит ли обучение сотрудников?",
                a: "Да, во всех тарифах. Перед запуском мы готовим инструкцию и проводим практическую сессию: что AI умеет, чего он не умеет и как проверять результат. В тарифе «Бизнес» дополнительно составляются отдельные регламенты для двух подразделений. Первый месяц мы остаёмся на связи по возникающим вопросам.",
            },
            {
                q: "Придётся ли переписывать старую систему?",
                a: "Практически никогда. Слой AI находится вне вашей системы и общается с ней по API, поэтому существующий код не трогается. Только если система совсем старая и подключиться к ней невозможно, применяется промежуточный вариант — доступ к базе на чтение или обмен файлами.",
            },
            {
                q: "Когда AI-интеграция не нужна?",
                a: "Когда в процессе нет порядка. Если данные разбросаны по нескольким файлам Excel и не определено, кто и что вносит, AI просто ускорит этот беспорядок. В таком случае сначала нужно навести порядок в процессе — мы говорим об этом прямо и предлагаем начать с автоматизации.",
            },
        ],
    },

    cta: {
        h: "Какой из ваших процессов требует больше всего ручной работы?",
        p: "На бесплатном аудите разберём ваши системы, скажем, где AI даст отдачу, а где нет, и назовём конкретную цену со сроком. Телефон: +998 90 954 12 62.",
        button: "Запросить бесплатный аудит",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/ai-integratsiya-hero.webp",
            alt: "Схема AI-интеграции: слой искусственного интеллекта подключён к CRM, ERP, сайту и Telegram-боту",
            caption: "Слой AI находится над существующими системами и общается с ними по API.",
            prompt: "Clean isometric technical diagram on a dark graphite background: a central glowing node labelled 'AI LAYER' connected by luminous cyan lines to four surrounding boxes labelled CRM, ERP / 1C, WEBSITE and TELEGRAM BOT. Small API badges on each connection line. Minimal, modern, violet and cyan accents, no photographic elements, no real brand logos. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-crm.webp",
            alt: "AI-ассистент в карточке CRM классифицирует обращение и предлагает следующий шаг",
            caption: "Обращение классифицируется само, а резюме попадает прямо в карточку CRM.",
            prompt: "Screenshot-style mockup of a CRM deal card in a dark UI: customer details on the left, and on the right an AI side panel showing an auto-generated summary, a priority tag 'HIGH', and a suggested next action button. Generic placeholder names and text, cyan accent color, crisp modern SaaS interface, no real brand names. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-hujjat.webp",
            alt: "Автоматическое распознавание счёта и перенос данных в поля системы 1С и ERP",
            caption: "Цифры из документа попадают в поля системы автоматически, а не руками.",
            prompt: "Split composition: on the left a scanned invoice document with several fields highlighted by thin cyan rectangles; on the right the same values appearing in a structured data form in an ERP-style dark interface, connected by soft glowing arrows. Generic placeholder invoice with unreadable filler text and neutral numbers, clean and technical look. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-xavfsizlik.webp",
            alt: "Безопасность данных при AI-интеграции: маскирование, шифрование и контроль прав доступа",
            caption: "В модель уходят только согласованные поля, персональные данные маскируются.",
            prompt: "Abstract security diagram on a dark background: a data stream flowing left to right through three labelled gates — 'MASKING', 'ENCRYPTION', 'ACCESS CONTROL' — before reaching a node labelled 'AI MODEL'. Some data blocks shown as blurred/redacted bars. Minimal line art with cyan and amber accents, technical infographic style, no people. 16:9.",
        },
        {
            src: "/assets/img/services/ai-integratsiya-hisobot.webp",
            alt: "Запрос отчёта обычными словами: AI возвращает ответ и график из базы данных",
            caption: "Для отчёта не нужны ни SQL, ни очередь в ИТ-отдел.",
            prompt: "Dark-themed analytics interface where a chat input at the bottom contains a natural-language business question, and above it the system has rendered an answer paragraph plus a bar chart and a small data table. Generic placeholder labels and numbers, violet and cyan accents, clean modern dashboard rendering, no real brand names. 16:9.",
        },
    ],

    related: ["sun-iy-intellekt", "ai-agent", "computer-vision", "crm-tizimlar", "biznes-avtomatlashtirish"],
};

const content = { uz, ru };

export default content;
